import React, { useEffect, useRef } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import useStyles from "./style";
import Typography from "@material-ui/core/Typography";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { useData } from "../../../../components/firebase/DataProvider";
import { firestore } from "../../../../components/firebase/FirebaseProvider";
import { findOnePromo } from "../../../../utils/promo";
import currency, {
  calculateHargaLevel,
  calculatePromoLevel,
} from "../../../../utils/currency";

function Item({
  alamatId,
  variantId,
  variant,
  callSetInvalidJumlah,
  index,
  setProducts,
  setProductsLevel,
}) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("340"));
  const classes = useStyles();
  const { level, cartRef, promo, global_komisi } = useData();
  const realVariantId = useRef((variantId?.split?.("_") ?? []).pop()).current;
  const variantRef = firestore.doc(
    `products/${variant?.product}/variants/${realVariantId}`
  );
  const productRef = firestore.doc(`products/${variant?.product}`);
  const [data, loading] = useDocumentData(variantRef, { idField: "id" });
  const [product, loadingProd] = useDocumentData(productRef, {
    idField: "id",
  });

  const promoFound = findOnePromo(product, promo);

  const produkValue =
    product?.product_value !== undefined &&
    product?.product_value !== "" &&
    !Number.isNaN(product?.product_value) &&
    product?.product_value >= 0
      ? product?.product_value
      : 1;
      
  const setPromoDB = async (promoRes, isType) => {
    try {
      await cartRef.set(
        {
          subcarts: {
            [alamatId]: {
              products: {
                [variantId]: {
                  promo: promoRes,
                  type: isType,
                },
              },
            },
          },
        },
        { merge: true }
      );
    } catch (error) {
      console.log("Error find promo : ", error);
    }
  };

  useEffect(() => {
    // console.log("ef2");
    if (product && !loadingProd) {
      const isType = product?.properties?.type
        ? product?.properties?.type
        : "normal";
      (async () => {
        if (promoFound) {
          setPromoDB(promoFound.id, isType);
        } else {
          setPromoDB("", isType);
        }
      })();
    }
  }, [product, loadingProd, promo, promoFound]);

  useEffect(() => {
    // console.log("ef5");
    if (data?.sku) {
      // console.log("logef5");
      callSetInvalidJumlah(
        data?.sku,
        data?.stok_available,
        alamatId,
        variant?.jumlah
      );
      const harga = promoFound
        ? calculatePromoLevel(
            data?.harga_normal,
            promoFound,
            level.level,
            global_komisi,
            produkValue
          )
        : calculateHargaLevel(
            data?.harga_normal,
            global_komisi,
            level?.level,
            produkValue
          );
      setProducts(data?.sku, variant?.jumlah, harga);

      const hargaBiasa = calculateHargaLevel(
        data?.harga_normal,
        global_komisi,
        level?.level,
        produkValue
      );
      setProductsLevel(data?.sku, variant?.jumlah, hargaBiasa);
    }
  }, [
    alamatId,
    callSetInvalidJumlah,
    data?.sku,
    data?.stok_available,
    variant?.jumlah,
    setProducts,
    setProductsLevel,
    data?.harga_normal,
    data?.id,
    promoFound,
    level.level,
    global_komisi,
    produkValue
  ]);

  const bayar = promoFound
    ? calculatePromoLevel(
        data?.harga_normal,
        promoFound,
        level.level,
        global_komisi,
        produkValue
      )
    : calculateHargaLevel(
        data?.harga_normal,
        global_komisi,
        level?.level,
        produkValue
      );

  return (
    <div>
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography className={classes.liquidPrimary}>
            Pesanan {index + 1}
          </Typography>
          {product?.properties?.type === "preorder" && (
            <div className={classes.boxPre}>
              <Typography color="primary" className={classes.liquidPre}>
                Preorder
              </Typography>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          width: "100%",
          padding: "5px",
        }}
      >
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              style={{
                width: 75,
                height: 75,
                marginRight: "10px",
                borderRadius: 4,
              }}
              src={data?.thumbnail?.[0]}
              alt="logo"
            />
          </div>
          <div style={{ marginLeft: "1.5%" }}>
            <div style={{ display: "flex" }}>
              <div style={{ display: "inline-grid" }}>
                <Typography
                  style={{
                    fontSize: 12,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                  }}
                >
                  {variant?.nama}
                </Typography>
              </div>
            </div>
            <div>
              <Typography
                className={classes.liquidSmallGrey}
                style={{ marginBottom: "3px", marginTop: "3px" }}
              >
                Variasi: {data?.variant2?.nilai}, {data?.variant1?.nilai}
              </Typography>
            </div>
            <div>
              <Typography
                // className={classes.liquidSmallGrey}
                style={{
                  fontSize: 12.3,
                  color: "grey",
                  marginBottom: "3px",
                  marginTop: "3px",
                }}
              >
                {variant?.jumlah} pcs
              </Typography>
            </div>
            <div style={matches ? { display: "flex" } : {}}>
              {promoFound && (
                <Typography
                  noWrap
                  className={classes.liquidSmallGrey}
                  style={{ marginRight: "10px" }}
                >
                  {currency(bayar)} / item
                </Typography>
              )}
              <Typography
                noWrap
                style={
                  promoFound && {
                    textDecoration: "line-through",
                  }
                }
                className={classes.liquidSmallGrey}
              >
                {currency(
                  calculateHargaLevel(
                    data?.harga_normal,
                    global_komisi,
                    level?.level,
                    produkValue
                  )
                )}{" "}
                / item
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Item;
